import Tree from 'ant-design-vue/es/tree'
import { reduceFn } from '@/utils/util'
export default {
  name: 'RenderTree',
  props: ['treeData', 'seleced', 'title', 'myTitle', 'isNoNum', 'notLogin', 'isHandle'],
  data() {
    return {
      reduceFn: reduceFn,
      form: this.$form.createForm(this, { name: 'RenderTree' }),
      expandedKeys: [0],
      visible: false,
      parent_name: '全部分类',
      parent_id: 0
    }
  },
  methods: {
    select(val) {
      console.log('val===', val)
      this.$emit('update:seleced', val[0] || '')
      this.$emit('change', val[0] || '')
    },
    renderTree(treeData) {
      return treeData.map((item) => {
        return (
          <Tree.TreeNode key={item.id}>
            <span slot="title" title={item.name}>
              {item.name}
            </span>
            {item.children.length ? this.renderTree(item.children) : ''}
          </Tree.TreeNode>
        )
      })
    }
  },
  render() {
    return (
      <div style="overflow: hidden;">
        {this.treeData && this.treeData.length ? (
          <Tree
            onSelect={(val, e) => this.select(val, e)}
            show-icon
            // default-expand-all
            defaultExpandedKeys={this.expandedKeys}
          >
            <a-icon slot="switcherIcon" type="down" />
            <Tree.TreeNode
              key={0}
              title={
                this.title ? (
                  <span style={{ color: '#333333', fontWeight: 'bold' }}>{this.title}</span>
                ) : (
                  <span style={{ color: '#333333', fontWeight: 'bold' }}>all category</span>
                )
              }
            >
              {this.renderTree(this.treeData)}
            </Tree.TreeNode>
          </Tree>
        ) : (
          <div></div>
        )}
      </div>
    )
  }
}
